import React from 'react';
import { useParams } from 'react-router-dom';
import { Helmet } from "react-helmet";
import blogPosts from '../../data/blogPosts.js';
import { Navbar, Footer } from '../../components';
import './blogPost.css';

const BlogPost = () => {
  const { id } = useParams(); // Get the post ID from the URL
  const post = blogPosts.find((p) => p.id === parseInt(id));

  if (!post) {
    return <h1>Post Not Found</h1>;
  }

  return (
    <div>
      <Helmet>
        <title>{post.title}</title>
        <meta name="description" content={post.description} />
        <meta name="keywords" content={post.keywords} />
      </Helmet>
      <Navbar />
      <div className="blog-post-container">
        <h1 className='text-dark bg-white'>{post.title}</h1>
        <p className="date">{post.date}</p>
        <img src={post.image} alt={post.title} className="blog-post-image" />
        <div
          className="blog-post-content text-white"
          dangerouslySetInnerHTML={{ __html: post.content }} // This renders HTML content safely
        />
      </div>
      <Footer />
    </div>
  );
};

export default BlogPost;
